import { render, staticRenderFns } from "./generic-form-wrapper.vue?vue&type=template&id=625e2d76"
import script from "./generic-form-wrapper.vue?vue&type=script&lang=js"
export * from "./generic-form-wrapper.vue?vue&type=script&lang=js"
import style0 from "./generic-form-wrapper.vue?vue&type=style&index=0&id=625e2d76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports